import React, { useEffect } from 'react';
import {
  ExclamationIcon,
  ExclamationCircleIcon,
  XCircleIcon,
  CheckCircleIcon,
  XIcon,
} from '@heroicons/react/solid';
import {
  useCommonDispatch,
  useCommonSelector,
} from '@wajeez-web/stores/common';
import { AlertType } from '@wajeez-web/stores/common';
import { CommonActions } from '@wajeez-web/stores/common';

interface AlertProps {
  target?: 'page' | 'modal';
}

const Alert: React.FC<AlertProps> = ({ target = 'page' }) => {
  const dispatch = useCommonDispatch();

  const {
    type,
    messages,
    for: alertFor,
  } = useCommonSelector((state) => state.common.alert);

  const getColor = () => {
    switch (type) {
      case AlertType.WARNING:
        return 'yellow';
      case AlertType.SUCCESS:
        return 'green';
      case AlertType.INFO:
        return 'blue';
      case AlertType.ERROR:
        return 'red';
    }

    return;
  };

  const getBgColor = () => {
    switch (type) {
      case AlertType.WARNING:
        return 'bg-yellow-50';
      case AlertType.SUCCESS:
        return 'bg-green-50';
      case AlertType.INFO:
        return 'bg-blue-50';
      case AlertType.ERROR:
        return 'bg-red-50';
    }

    return;
  };

  const getIcon = () => {
    switch (type) {
      case AlertType.WARNING:
        return <ExclamationIcon className="h-5 w-5 text-yellow-500 " />;
      case AlertType.SUCCESS:
        return <CheckCircleIcon className="h-5 w-5 text-green-500 " />;
      case AlertType.INFO:
        return <ExclamationCircleIcon className="h-5 w-5 text-blue-500 " />;
      case AlertType.ERROR:
        return <XCircleIcon className="h-5 w-5 text-red-500 " />;
    }

    return;
  };

  useEffect(() => {
    if (messages && messages.length > 0) {
      setTimeout(() => {
        dispatch(CommonActions.clearAlert());
      }, 2000);
    }
  }, [messages]);

  return (
    <div
      className={`absolute top-30 min-w-[300px] max-w-[50%] w-fit justify-center right-0 left-0  mx-auto z-50 space-y-2`}
    >
      {messages &&
        target === alertFor &&
        messages.map((item, i) => (
          <div
            key={item.code + i}
            className={` text-${getColor()}-500 text-sm  overflow-clip border border-${getColor()}-500 ${getBgColor()} p-4 flex flex-row align-middle items-center justify-between w-full rounded-md`}
          >
            <div className="flex flex-row space-s-2  overflow-clip w-full">
              {getIcon()}{' '}
              <div className=" overflow-clip w-full">{item.message}</div>
            </div>
            <XIcon
              onClick={() => dispatch(CommonActions.clearAlert())}
              className={`text-${getColor()}-500 cursor-pointer hover:text-${getColor()}-400 h-4 w-4 ms-2`}
            />
          </div>
        ))}
    </div>
  );
};

export default Alert;
